import React, { Component } from "react";
import AboutTop from "./AboutTop";
import { Row, Col, Container } from "reactstrap";
import Fade from "react-reveal/Fade";
import { Helmet } from "react-helmet";
import TraderLogo from "./TraderLogo";

class About extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>
            About Us | Rebuild Construction Services Melbourne | UP TO 50% OFF
            FOR FIRST TIMERS{" "}
          </title>
          <meta
            name="description"
            content="About Us |Rebuild Construction Services Melbourne"
          />
        </Helmet>
        <AboutTop />
        <Container>
          <Row className="pt-5 pb-3 ">
            <Col>
              <Fade bottom>
                <div>
                  <h1>ABOUT US</h1>
                  <p>
                    At Rebuild Construction Services, we specialise in concrete
                    asset inspection, repair, and remediation, as well as the
                    supply and installation of precast panels, soffit works,
                    waterproofing, and finishing solutions.
                  </p>

                  <p>
                    From cosmetic upgrades to specialised structural work, we
                    pride ourselves on delivering strong and reliable outcomes
                    tailored to projects of all sizes. For external property
                    maintenance, garden clean-ups, and rubbish removal, we
                    recommend{" "}
                    <a
                      href="https://twomatespropertycare.com.au"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Two Mates Property Care
                    </a>
                    , a trusted local Melbourne service. Our commitment to
                    excellence, combined with years of experience, ensures every
                    project is completed to the highest standard.
                  </p>
                  <p>
                    These opportunities reflect our ability to perform under
                    high-pressure, evolving conditions while maintaining strict
                    adherence to timelines, budgets, and quality standards.
                  </p>
                  <p>
                    At Rebuild Construction, we’re dedicated to building
                    solutions that last.
                  </p>
                </div>
                <div>
                  <h1>OUR MISSION</h1>
                  <p>
                    At Rebuild Construction, our mission is to provide
                    meaningful employment opportunities for individuals impacted
                    by the justice system. We understand the challenges and
                    stigmas that accompany reintegration into society and
                    believe in the transformative power of employment.
                  </p>

                  <p>
                    Our organisation is dedicated to creating a supportive
                    environment where individuals can develop valuable skills,
                    regain confidence, and find purpose. Through tailored
                    training programs and mentorship, we empower our employees
                    to thrive both professionally and personally.
                  </p>
                  <p>
                    Beyond job placement, we are committed to supporting our
                    employees in their journey toward successful reintegration.
                    Recognising the complexities of life beyond the justice
                    system, we offer comprehensive support services, including
                    counselling, housing, and transportation assistance.
                  </p>
                  <p>
                    At Rebuild Construction, we believe in second chances and
                    the inherent dignity of every individual. By providing
                    employment opportunities and holistic support, we are not
                    just building a workforce; we are building a brighter future
                    for our employees and our communities.
                  </p>
                  <p>We are a proudly accredited social enterprise.</p>
                </div>
                <div>
                  <h1>OUR VALUES</h1>
                  <p>
                    Safety is the foundation of everything we do. We believe
                    everyone deserves a safe workplace, and we prioritise the
                    well-being of our team and clients above all else. Rebuild
                    Construction strictly adheres to all applicable OH&S
                    legislation and employs world-class methods to manage risk
                    effectively. Our specialised silica dust management plan
                    reflects our commitment to safety, enhancing team morale
                    while enabling us to deliver efficient, high-quality work
                  </p>

                  <p>
                    We foster a respectful, supportive, and inclusive workplace
                    where every team member’s unique strengths contribute to
                    better solutions and results. Rebuild Construction is proud
                    to uphold the principles of the Respect Code for the
                    Building and Construction Industry, the Equal Opportunity
                    Act 2010 (Vic), the Sex Discrimination Act 1984 (Cth), and
                    the Fair Work Act 2009 (Cth). By embracing diversity, we
                    build stronger teams and achieve shared success.
                  </p>
                  <p>
                    Trust and respect are the cornerstones of our relationships
                    with clients, industry peers, and the local community. We
                    operate with honesty, transparency, and accountability in
                    every decision and action. Ethical practices guide us in
                    delivering fair, sustainable outcomes. We collaborate
                    closely with clients, solving problems together to ensure
                    projects are completed on time and to the highest standards.
                    Our expertise and attention to detail underpin the superior
                    quality of our work and our dedication to exceptional
                    customer service.
                  </p>
                </div>
                <TraderLogo />
              </Fade>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default About;
